import { render } from "./Procedures.vue?vue&type=template&id=adecc5ea&scoped=true"
import script from "./Procedures.vue?vue&type=script&lang=js"
export * from "./Procedures.vue?vue&type=script&lang=js"

import "./Procedures.vue?vue&type=style&index=0&id=adecc5ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adecc5ea"]])

export default __exports__